import isProd from './isProduction'

export const endpoints = (prod = isProd()) => ({
  cfeApiUrl: prod ? 'https://www.easybib.com/api' : '//playground.easybib.com/api',
  wptAppUrl: prod ? 'https://writing.easybib.com' : '//writing-playground.easybib.com',
  wptApiUrl: prod ? 'https://wbe-prod-api.easybib.com' : '//writing-backend.playground.easybib.com',
})

export default function getWidgetProps({
  theme = 'wfe',
  headingText = 'Try our smart proofreader',
  subheadingText = `Don't worry, your writing won't be searchable publicly.`,
} = {}) {
  const { cfeApiUrl, wptAppUrl, wptApiUrl } = endpoints()

  return {
    theme,
    headingText,
    subheadingText,
    cfeAuth: true,
    cfeApiUrl,
    wptAppUrl,
    wptApiUrl,
  }
}
